import { render, staticRenderFns } from "./ModalImageView.vue?vue&type=template&id=85a456da&scoped=true"
import script from "./ModalImageView.vue?vue&type=script&lang=ts"
export * from "./ModalImageView.vue?vue&type=script&lang=ts"
import style0 from "./ModalImageView.vue?vue&type=style&index=0&id=85a456da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a456da",
  null
  
)

export default component.exports